var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actImg)?_c('div',{staticClass:"banner-container"},[_c('img',{staticClass:"banner-image",attrs:{"src":_vm.actImg,"alt":"banner"},on:{"click":_vm.handleActivityJump}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb6e51a","hasScoped":true,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/component/post-activity/index.vue
// module id = 745
// module chunks = 0 2